export const readBackendConfig = (config, loading) => {
    if (loading) {
        return {};
    }

    if (config && config.configProvider) {
        return config.configProvider
    }

    return {};
}